
import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "./SwitchCompany.scss";

import { withTranslation } from "react-i18next";
import ProfileService from "../../core/service/ProfileService";
import company_logo from "../../images/C_profile.jpg";
import doodle from "../../images/doodle.jpg";
import { useNavigate } from "react-router-dom";
import {
  LS_AUTHORITY_KEY,
  LS_USER_ONBOARD_KEY,
  LS_DV_FILTER_KEY,
  LS_COMP_FILTER_KEY,
  LS_SELECTED_MAT_ISSUE_YEAR,
  LS_GHG_DV_FILTER_KEY,
  LS_CONTENT_BLOCKS_FILTER_KEY,
  LS_ESG_FILTER_KEY,
  LS_DCE_FILTER_KEY,
  LS_DCE_SUBMISSION_FILTER_KEY
} from "../../core/constants/common";
import { RegulationContext } from "../../App";
import LoginService from "../../core/service/login-service";
import { hasGoalsKpiNavAccess } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions";

const SwitchCompany = ({ t }) => {

  const FILTER_STORAGE_KEYS_TO_CLEAR_ON_SWITCH = [
  LS_DV_FILTER_KEY,
  LS_COMP_FILTER_KEY,
  LS_SELECTED_MAT_ISSUE_YEAR,
  LS_GHG_DV_FILTER_KEY,
  LS_CONTENT_BLOCKS_FILTER_KEY,
  LS_ESG_FILTER_KEY,
  LS_DCE_FILTER_KEY,
  LS_DCE_SUBMISSION_FILTER_KEY
];

  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const { setGlbRegulation } = useContext(RegulationContext);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = () => {
    ProfileService.getConsultantCompanies().then(res => {
      if (res.status !== 200) return;

      setCompanies(res.data);
    }).catch(err => { });
  };

  const switchCompany = (company) => {
    ProfileService.switchCompanyAsConsultant(company.id).then(res => {
      if (res.status !== 200) return;

      const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
      lsData['profile']['company'] = company;
      localStorage.setItem(LS_AUTHORITY_KEY, JSON.stringify(lsData));
      // Reset the selected regulations if any
      setGlbRegulation({});
      // Clear stale per-company filter selections so they don't bleed into the new company's views
      FILTER_STORAGE_KEYS_TO_CLEAR_ON_SWITCH.forEach((key) => localStorage.removeItem(key));
      // Call profileComplete to update userOnboardData
      profileCompletion(company.id);
    }).catch(err => { });
  };

  const profileCompletion = async (companyId) => {
    LoginService.profileComplete(companyId)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            LS_USER_ONBOARD_KEY,
            JSON.stringify(response.data)
          );
          const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || 'null');
          // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
          if (hasGoalsKpiNavAccess(buildHierarchyPermissions(Array.isArray(lsDat?.roles) ? lsDat.roles : []))) {
            navigate("/company_admin/goals_kpi/dashboard");
          } else {
            navigate("/company_admin/");
          }
        }
      })
      .catch((error) => {
        const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || 'null');
        // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
        if (hasGoalsKpiNavAccess(buildHierarchyPermissions(Array.isArray(lsDat?.roles) ? lsDat.roles : []))) {
          navigate("/company_admin/goals_kpi/dashboard");
        } else {
          navigate("/company_admin/");
        }
      });
  };

  return (
    <section className="Switch_page_section">
      <div className="Switch_Form">
        <div className="Switch_Form_card">
          {
            companies?.map((company) =>
              <div className="Switch_box" key={company.id}>
                <div className="Switch_box_in">
                  <img src={doodle} />
                </div>
                <div className="Switch_box_Companylogo">
                  <div className="Switch_box_Companylogo_in">
                    <img src={company_logo} />
                  </div>
                </div>
                <div className="p-2">
                  <h5>{company.legalName}</h5>
                  <div className="p-2">
                    <Button variant="primary" onClick={() => switchCompany(company)}>{t('Proceed.label')}</Button>
                  </div>
                </div>

              </div>
            )
          }
        </div>
      </div>
    </section>
  )
};


export default withTranslation()(SwitchCompany);
